import { Tooltip as ReactTooltip } from "react-tooltip";
import { EmptySpace } from "./EmptySpace";
import { SeatIcon } from "./SeatIcon";

export const Seat = ({
  seat,
  handleSeatClick,
  selectedSeatIds,
  seatIcon,
  selectedSeatIcon,
  reservedSeatIcon,
  emptySpace,
}) => {
  if (seat?.isEmptySpace) {
    return emptySpace ? emptySpace : <EmptySpace />;
  }

  let classStatus = "";

  if (selectedSeatIds && selectedSeatIds.includes(seat.seatId)) {
    classStatus = "selected";
  }

  if (seat.isReserved) {
    classStatus = "reserved";
  }

  return (
    <div
      key={seat.seatId}
      className={`seat-item ${classStatus}`}
      onClick={() => handleSeatClick && handleSeatClick(seat)}
      data-tooltip-id={`tooltip-${seat.seatId}`}
    >
      {!seatIcon && !selectedSeatIcon && !reservedSeatIcon && (
        <SeatIcon state={classStatus} label={seat.seatDisplayName} />
      )}
      {!["selected", "reserved"].includes(classStatus) && seatIcon}
      {classStatus === "selected" && selectedSeatIcon}
      {classStatus === "reserved" && reservedSeatIcon}
      {!seat?.isReserved && seat?.seatDisplayName && seat?.price && (
        <ReactTooltip
          id={`tooltip-${seat.seatId}`}
          place="top"
          variant="dark"
          content={`Seat number: ${seat.seatDisplayName} - Fare: $${Number(
            seat.price
          ).toFixed(2)}`}
        />
      )}
    </div>
  );
};
